import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from '@/lang/en.json'

Vue.use(VueI18n)

export const languages = ['en']
export const defaultLanguage = languages[0]

export default new VueI18n({
  locale: defaultLanguage,
  fallbackLocale: defaultLanguage,
  messages: {
    en: en
  }
})
